import { render, staticRenderFns } from "./CustomerYanJianKangQuXian.vue?vue&type=template&id=32968769&scoped=true&"
import script from "./CustomerYanJianKangQuXian.vue?vue&type=script&lang=js&"
export * from "./CustomerYanJianKangQuXian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32968769",
  null
  
)

export default component.exports